import { CustomizedAttributes, LeagueSeason } from './../../../data/mygolf.data';
import { MultiCourseCompetitionService } from './../../../providers/multi-course-competition-service/multi-course-competition.service';
import { Platform, ToastController } from '@ionic/angular';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { Observable, Subscription, finalize } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { PlayerHomeInfo, PlayerInfo } from 'src/data/player-data';
import { PlayerHomeDataService } from 'src/redux/player-home/player-home-data-service';
import * as globals from 'src/globals';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { MessageDisplayUtil } from 'src/message-display-utils';

import { customizedItems } from 'src/app/customized-pages/customized-attributes';

import { AppCustomizerService } from 'src/providers/app-customizer-service/app-customizer.service';

@Component({
  selector: 'app-tabs',
  templateUrl: 'tabs.page.html',
  styleUrls: ['tabs.page.scss'],
})
export class TabsPage implements OnInit, OnDestroy {
  public playerHomeInfo$: Observable<PlayerHomeInfo>;
  public player$: Observable<PlayerInfo>;
  public playerPhoto$: Observable<string>;
  constructor(
    private router: Router,
    private playerHomeService: PlayerHomeDataService,
    private mg2uUtil: mygolfUtils,
    private flightService: ClubFlightService,
    private platform: Platform,
    private toastCtrl: ToastController,
    private customizerService: AppCustomizerService,
    private multiCourseCompService: MultiCourseCompetitionService
  ) {
    // this.router.events
    //   .pipe(filter(event => event instanceof NavigationEnd))
    //   .subscribe((event: NavigationEnd) => {

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(async (event: NavigationEnd) => {
        // Add all routes where tabs should be hidden
        const hiddenRoutes = [
          'competition-flights',
          'competition-players',
          'competition-teams',
          'competition-teams-details',
          'competition-teams-leaderboard',
          'multi-course-competition-flights',
          'multi-course-competition-players',
          'multi-course-competition-teams',
          'multi-course-competition-teams-details',
          'multi-course-competition-leaderboard',
          'multi-course-competition-rounds',
          'course-lists',
          'setup-player-courses',
          'competition-leaderboard',
          'competition-sponsors',
          'competition-prizes',
          'wagc-qlfr-profile',
          // 'epsl-player-home',
        ];
        let _len = event.url.split('/')?.length - 1;
        const _url = event.url.split('/')[_len];
        // event.url.split('/')[_len];
        this.showTabs = !hiddenRoutes.includes(_url);
        console.debug(
          'hiding tabs : ',
          this.showTabs,
          event.url,
          _url,
          _len,
          event.url.split('/')[_len],
          hiddenRoutes
        );
      });
    // this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();

    // this.player$ = this.playerHomeInfo$.pipe(
    //   filter(Boolean),
    //   map((playerHome: PlayerHomeInfo) => playerHome.player))

    this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();

    // this.ref.detectChanges();
    this.player$ = this.playerHomeInfo$.pipe(
      filter(Boolean),
      map((playerHome: PlayerHomeInfo) => playerHome.player)
    );
    this.player$.subscribe(res => {});

    // this.playerPhoto$ = this.playerHomeService.playerPhoto();

    this.playerPhoto$ = this.player$.pipe(
      map((playerInfo: PlayerInfo) => {
        if (playerInfo.photoUrl) {
          return playerInfo.photoUrl;
        } else if (!playerInfo.photoUrl && playerInfo.thumbnail) {
          return playerInfo.thumbnail;
        } else {
          return '';
        }
      })
    );
    this.multiCourseCompService.getMultiCourseDetails().subscribe((compData: LeagueSeason) => {
      this.leagueSeason = compData;
    });
  }

  leagueSeason: LeagueSeason;
  ngOnInit() {
    if (globals.appType === 'club' && globals.appClient?.length) {
      // this.customizedAttributes = CustomizedAttributes;
      this.getCustomizedAttributes();
    }
  }

  ngOnDestroy(): void {
      if(this.subCustAttribute) {
        this.subCustAttribute.unsubscribe();
        this.subCustAttribute = null;
      }
  }

  onHomeClick() {
    this.router.navigate(['/tab3']);
  }

  onProfileClick() {
    const currentRoute = this.router.url;
    console.debug('current route : ', currentRoute);
    if (currentRoute.includes('profile')) {
      return;
    }
    // this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();

    // this.player$ = this.playerHomeInfo$.pipe(
    //   filter(Boolean),
    //   map((playerHome: PlayerHomeInfo) => playerHome.player))

    // this.player$ = this.playerHomeInfo$.pipe(map((playerHomeInfo: PlayerHomeInfo) => playerHomeInfo.player))
    //
    let params: NavigationExtras = {
      state: {
        type: 'playerProfile',
        // player:this.player$
      },
    };
    if (
      (globals.appType === 'specific' || globals.appType === 'club') &&
      globals.appClient?.length
    ) {
      //! to add customized service redirection page here
      this.customizerService.goToPlayerProfile(params);
      // this.router.navigate(['/tabs/wagc-profile'], params);
    } else this.router.navigate(['tabs/profile'], params);
  }

  updatedColor: number = 0;

  // getSVGImageClass(additionalClass: string) {
  //   if (this.updatedColor > 0)
  //     return additionalClass + ' ' + 'svg-filter';
  //   else return additionalClass;
  // }
  getSVGImageClass(additionalClass: string) {
    // console.debug("get svg image class : ", this.isClubSpecific, this.updatedColor)
    if (this.updatedColor > 0) return additionalClass + ' ' + 'svg-filter';
    else if (this.mg2uUtil.getClubSpecific()) return additionalClass + ' ' + 'svg-filter';
    else return additionalClass;
  }

  subCustAttribute: Subscription;
  customizedAttributes: CustomizedAttributes; // = CustomizedAttributes;

  showFooter: boolean = true;
  calledCustomizedAttributes: boolean = false;
  getCustomizedAttributes() {


    if(this.calledCustomizedAttributes) return;
    if (this.subCustAttribute) return;
    this.calledCustomizedAttributes = true;
                console.debug("[customized attributes] get attributes : ",
              this.customizedAttributes,
              globals.organizerId, this.customizedAttributes?.leagueSeasons
            );
    this.subCustAttribute = this.customizerService.getCustomizedAttributes()
    .subscribe(data => {
      if (data) {
        // this.customizedAttributes = data;
      if (data) this.customizedAttributes = data;

        let _orgId = globals.organizerId;
        let _seasonId = Number(data?.leagueSeasons?.currentSeason?.seasonId); //this.leagueSeason?.id;
        // this.multiCourseCompService.refreshCompetitionDetails(_orgId, _seasonId);
        console.debug("[customized attributes] show footer : ", data?.showFooter, data, this.customizedAttributes)
        if (data.showFooter !== undefined) {
          this.showFooter = data?.showFooter;
          const footer = document.getElementById('footerTab');
          const wagcHome = document.getElementsByName('app-wagc-home');
          if(!this.showFooter) {
            // wagcHome[0]['style'].padding = '0';
            footer[0]['style'].display = 'none';
          }

        }
        if(this.subCustAttribute) {
          this.subCustAttribute.unsubscribe();
          this.subCustAttribute = null;
        }
      }
    },(error)=>{

        if(this.subCustAttribute) {
          this.subCustAttribute.unsubscribe();
          this.subCustAttribute = null;
        }
    });
  }
  // getCustomizedAttributes() {
  //   if (this.subCustAttribute) return;
  //   this.subCustAttribute = this.flightService.getCustomizedAttributes(null, true)
  //   .subscribe((data: any) => {
  //     if (data) {
  //       this.customizedAttributes = data;
  //     }
  //     if(this.subCustAttribute) {
  //       this.subCustAttribute.unsubscribe();
  //       this.subCustAttribute = null;
  //     }
  //   },(error)=>{

  //     if(this.subCustAttribute) {
  //       this.subCustAttribute.unsubscribe();
  //       this.subCustAttribute = null;
  //     }
  //   });
  // }

  showFooterItem(itemId: string) {
    if (!this.customizedAttributes) {
      if (itemId === 'teeBookings') return true;
      else if (itemId === 'faq') return true;
      else if (itemId === 'playerProfile') return true;
      else if (itemId === 'drawList') return false;
      else if (itemId === 'leaderboard') return false;
      else return true;
    }
    const footerItem = this.customizedAttributes?.footerItems?.find(
      (item: any) => item.id === itemId
    );
    if (!footerItem) return false;
    else return footerItem?.hide ? false : true;
  }

  onClickFooterItem(itemId: string) {

        const _playerHomeAttributes = this.mg2uUtil.getSpecificAppAttributePage('playerHome');
        const _homeClubId = this.mg2uUtil.getHomeClub()?.clubId;
        const _clubSpecific = _playerHomeAttributes?.clubSpecificThemes?.find((cst)=>{
          return cst?.clubId === _homeClubId
        });
          const footerBookings = _clubSpecific?.homeSpecific?.footerMyBookings;
          const footerBookingsUrl = _clubSpecific?.homeSpecific?.footerBookingsUrl;
          console.debug("on click footer item [00] : ", itemId,
            _playerHomeAttributes,_homeClubId, this.mg2uUtil.getClubSpecific(),
            this.mg2uUtil.getClubMembership(),
            _clubSpecific?.homeSpecific,
             footerBookings, footerBookingsUrl)
    if (!this.customizedAttributes) {
      if (itemId === 'teeBookings') {
        const _playerHomeAttributes = this.mg2uUtil.getSpecificAppAttributePage('playerHome');
        const _homeClubId = this.mg2uUtil.getHomeClub()?.clubId || (this.mg2uUtil.getClubSpecific()&&this.mg2uUtil.getClubMembership()?this.mg2uUtil.getClubMembership()?.club?.id:null);
        const _clubSpecific = _playerHomeAttributes?.clubSpecificThemes?.find((cst)=>{
          return cst?.clubId === _homeClubId
        });

        let params: NavigationExtras = {
          state: {
            fromClub: false,
            fromHome: true,
            userType: 'player',
            isClubSpecific: this.mg2uUtil.getClubSpecific(),
            club: this.mg2uUtil.getHomeClub(),
            clubInfo: this.mg2uUtil.getHomeClub(),
            clubSpecificThemes: _clubSpecific,
          },
        };
        if(globals.appType === 'main' &&  _clubSpecific?.homeSpecific?.enable) {
          const footerBookings = _clubSpecific?.homeSpecific?.footerMyBookings;
          const footerBookingsUrl = _clubSpecific?.homeSpecific?.footerBookingsUrl;
          // console.debug("on click footer item : ", itemId, this.customizedAttributes,
          //   _clubSpecific?.homeSpecific,
          //    footerBookings, footerBookingsUrl)
          if(footerBookings !== undefined) {
            if(footerBookings === 'both') {
              this.router.navigate(['tabs/booking-home'], params);
            } else if(footerBookings === 'tee') {
this.router.navigate(['tabs/booking-home'], params);
            } else if(footerBookings === 'facility') {
this.router.navigate(['player-facility-home'], params);
            } else if(footerBookings === 'other') {
              this.router.navigate([footerBookingsUrl], params);
            } else {

              this.router.navigate(['tabs/booking-home'], params);
            }

          } else {

              this.router.navigate(['tabs/booking-home'], params);
          }

        } else {

        this.router.navigate(['tabs/booking-home'], params);
        }
      }
      else if (itemId === 'faq') this.router.navigate(['tabs/faq']);
      else if (itemId === 'playerProfile') this.onProfileClick();
      else if (itemId === 'playerHome') this.onPlayerHomeClick();

      return;
    }
    if (itemId === 'playerHome') {
      this.onPlayerHomeClick();
      return;
    }
    const footerItem = this.customizedAttributes?.footerItems?.find(
      (item: any) => item.id === itemId
    );
    if (!footerItem) return false;
    if (!this.getFooterItemEnable(itemId)) {
      const message =
        footerItem?.disableMessage ||
        'This menu item is currently disabled. Please try again later.';
      MessageDisplayUtil.showErrorToast(message, this.platform, this.toastCtrl, 3000, 'bottom');
      return;
    }
    if (itemId === 'playerProfile') {
      this.onProfileClick();
      return;
    }
    if (footerItem?.onClickAction) {
      let _isGuest: boolean = false;
      if (this.customizerService.getRosterInfo('groupColor') === null) {
        _isGuest = true;
      }

      const action = footerItem?.onClickAction;
      switch (action?.actionType) {
        case 'externalURL':
          // this.openWithInAppBrowser(action?.actionValue);
          break;
        case 'internalURL':
          if (itemId === 'drawList') {
            if (!this.leagueSeason) return;
            this.multiCourseCompService
              .checkCompFlights(!_isGuest)
              .then((result: any) => {
                if (result?.success) {
                  if (result?.page === 'flights') {
                    let navigationExtras: NavigationExtras = {
                      state: {
                        seasonId: this.leagueSeason?.id,
                        leagueSeason: this.leagueSeason,
                        myFlightMode: !_isGuest,
                      },
                    };
                    this.router.navigate(
                      ['tabs/multi-course-competition-flights'],
                      navigationExtras
                    );
                  } else if (result?.page === 'schedules') {
                    const comp = this.leagueSeason?.seasonCompetitions.sort((a, b) => {
                      return a.competitionSequence - b.competitionSequence;
                    })[0]?.competition;

                    let navigationExtras: NavigationExtras = {
                      state: {
                        seasonId: this.leagueSeason?.id,
                        leagueSeason: this.leagueSeason,
                        competition: comp,
                        compId: comp?.id,
                        roundNo: 1, //this.gameRound.roundNo,
                        gameRound: comp?.gameRounds?.find((gr: any) => gr.roundNo === 1),
                        flights: null,
                        myFlightMode: !_isGuest,
                      },
                    };
                    this.router.navigate(
                      ['tabs/multi-course-competition-schedules'],
                      navigationExtras
                    );
                  }
                }
              })
              .catch((error: any) => {
                if (!error) {
                  const message = 'Drawlist is not ready yet. Please try again later.';
                  MessageDisplayUtil.showErrorToast(
                    message,
                    this.platform,
                    this.toastCtrl,
                    3000,
                    'bottom'
                  );
                }
              });
          } else if (itemId === 'leaderboard') {
            const navigationExtras: NavigationExtras = {
              state: {
                seasonId: this.leagueSeason?.id,
                leagueSeason: this.leagueSeason,
              },
            };
            this.router.navigate(['tabs/multi-course-competition-leaderboard'], navigationExtras);
          } else this.router.navigate([action?.actionValue]);
          break;
        case 'page':
          break;
      }
    }
  }

  getFooterItemEnable(itemId: string) {
    if (!this.customizedAttributes) return;
    const footerItem = this.customizedAttributes?.footerItems?.find(
      (item: any) => item.id === itemId
    );
    if (!footerItem) return false;
    else return footerItem?.disabled ? false : true;
  }

  getFooterItemIcon(footerId: string) {
    if (!this.customizedAttributes) return;
    const footerItem = this.customizedAttributes?.footerItems?.find(
      (item: any) => item.id === footerId
    );
    if (!footerItem) return false;

    if (footerItem?.iconUrl) return footerItem?.iconUrl;
    // else return 'assets/image/homeImg/bookingStatistics_2x.png';
  }

  showTabs: boolean = true;

  onPlayerHomeClick() {
    this.customizerService.goToPlayerHome();
  }
}
